import { OPT_IN_ALL_EVENT } from "../types";
import { getUserDecision } from ".";
/**
 * Listen to opt-in so we can safely print the UUID of the current user to the
 * `PrintUuidShortcode.php` HTML tag.
 */

function printUuidToShortcode() {
  document.addEventListener(OPT_IN_ALL_EVENT, function () {
    var consent = getUserDecision();

    if (consent !== false) {
      document.querySelectorAll(".rcb-consent-print-uuid").forEach(function (element) {
        return element.innerHTML = consent.uuid;
      });
    }
  });
}

export { printUuidToShortcode };